const navLinks = [
  {
    name: 'nav.home',
    to: '/networks',
    requiresLogin: false,
  },
  {
    name: 'nav.media',
    to: '/media/',
    requiresLogin: false,
  },
  {
    name: 'nav.courses',
    to: '/courses',
    requiresLogin: true,
  },
  {
    name: 'Nav.admin',
    to: '/dashboard',
    requiresLogin: true,
    requiresAdmin: true,
  },
  {
    name: 'Nav.profile',
    to: '/profile/',
    requiresLogin: true,
  },
  {
    name: 'network.Messages',
    to: '/messages',
    requiresLogin: true,
  },
];

export default navLinks;
